import { EVENTS_APP_ID } from './app-definitions';
export const EVENTS_COMMUNITY_FORUM_URL = 'https://www.wix-events-community.com';
export const getBillingUrl = (msid, referral) => `https://www.wix.com/store/plans?v=1&appDefId=${EVENTS_APP_ID}&siteGuid=${msid}${referral ? `&referralAdditionalInfo=${referral}` : ''}#/`;
export const draftEventPreviewUrlQueryParamName = 'draftPreviewToken';
export const DASHBOARD_PATHS = {
    MY_EVENTS: '',
    NEW_EVENT: '/new',
    EVENT_DETAILS: (eventId) => `/${eventId}/event-details`,
    GUEST_LIST: (eventId) => `/${eventId}/guest-list`,
    DRAFTS: '/drafts',
    CATEGORIES: '/categories',
    OCCURRENCES: '/occurrences',
};
export const NEW_DASHBOARD_PATHS = {
    MY_EVENTS: '',
    NEW_EVENT: '/new',
    EVENT_DETAILS: (eventId) => `/event/${eventId}/overview`,
    ORDERS: (eventId) => `/event/${eventId}/orders`,
    RSVP_GUESTS: (eventId) => `/event/${eventId}/rsvp-guests`,
};
//# sourceMappingURL=urls.js.map